import { OnMounted } from '@studyportals/vue-platform';

export class AppCB implements OnMounted {
	public readonly page: string;

	public constructor(page: string | undefined) {
		this.page = page || 'BodyEditor';
	}

	public mounted(): void {
		// Hook mounted
	}
}
